var render, staticRenderFns
import script from "./flexboxItem.vue?vue&type=script&lang=js&"
export * from "./flexboxItem.vue?vue&type=script&lang=js&"
import style0 from "./flexboxItem.vue?vue&type=style&index=0&id=db8b4d06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8b4d06",
  null
  
)

export default component.exports